export enum LicensePlateTypes {
    LICENSE_PLATE_CAR_STANDARD = 'LICENSE_PLATE_CAR_STANDARD',
    LICENSE_PLATE_CAR_PERSONALIZED = 'LICENSE_PLATE_CAR_PERSONALIZED'
}

export interface LicensePlateConfiguration {
    chosenLicensePlateText: string;
    chosenLicensePlateType: LicensePlateTypes;
}